/* tslint:disable */
/* eslint-disable */
/**
 * Voice Feature Configuration API
 * To support the new ABV service, a new interface between the VFC Portal (Voice Feature Configuration Portal) and SPP CVoIP is necessary so that the VFC Portal can send transactions to SPP CVoIP to provision Calling Features for ABV TNs in the NOKIA nTAS Network Element.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: sw8927@att.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import type { RequestArgs } from "./base";
// @ts-ignore
import { BASE_PATH, BaseAPI, COLLECTION_FORMATS, operationServerMap, RequiredError } from "./base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
    assertParamExists,
    createRequestFunction,
    DUMMY_BASE_URL,
    serializeDataIfNeeded,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    toPathString,
} from "./common";
import type { Configuration } from "./configuration";

/**
 *
 * @export
 * @interface AddCallingFeaturesRequest
 */
export interface AddCallingFeaturesRequest {
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof AddCallingFeaturesRequest
     */
    customerAccountId: string;
    /**
     * Provisioning priority for this transaction
     * @type {number}
     * @memberof AddCallingFeaturesRequest
     */
    priority: number;
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof AddCallingFeaturesRequest
     */
    orderNumber: string;
    /**
     *
     * @type {HuntTypeSchema}
     * @memberof AddCallingFeaturesRequest
     */
    huntType?: HuntTypeSchema;
    /**
     *
     * @type {DirectedGroupIndicatorSchema}
     * @memberof AddCallingFeaturesRequest
     */
    directedGroupIndr?: DirectedGroupIndicatorSchema;
    /**
     *
     * @type {Array<TnDetails>}
     * @memberof AddCallingFeaturesRequest
     */
    tnList: Array<TnDetails>;
}

/**
 *
 * @export
 * @interface AllCallingFeaturesForAccountResponse
 */
export interface AllCallingFeaturesForAccountResponse {
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof AllCallingFeaturesForAccountResponse
     */
    customerAccountId: string;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof AllCallingFeaturesForAccountResponse
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof AllCallingFeaturesForAccountResponse
     */
    errorMessage?: string;
    /**
     *
     * @type {Array<CallingFeatureData>}
     * @memberof AllCallingFeaturesForAccountResponse
     */
    callingFeatureList?: Array<CallingFeatureData>;
}

/**
 *
 * @export
 * @interface AsyncCallingFeatureData
 */
export interface AsyncCallingFeatureData {
    /**
     * Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
     * @type {number}
     * @memberof AsyncCallingFeatureData
     */
    groupId: number;
    /**
     * Name of the feature to be retrieved
     * @type {string}
     * @memberof AsyncCallingFeatureData
     */
    featureName: AsyncCallingFeatureDataFeatureNameEnum;
    /**
     *
     * @type {HuntTypeSchema}
     * @memberof AsyncCallingFeatureData
     */
    huntType?: HuntTypeSchema;
    /**
     *
     * @type {DirectedGroupIndicatorSchema}
     * @memberof AsyncCallingFeatureData
     */
    directedGroupIndr?: DirectedGroupIndicatorSchema;
    /**
     *
     * @type {Array<AsyncResponseTnDetails>}
     * @memberof AsyncCallingFeatureData
     */
    tnList?: Array<AsyncResponseTnDetails>;
}

export const AsyncCallingFeatureDataFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;

export type AsyncCallingFeatureDataFeatureNameEnum = (typeof AsyncCallingFeatureDataFeatureNameEnum)[keyof typeof AsyncCallingFeatureDataFeatureNameEnum];

/**
 *
 * @export
 * @interface AsyncResponseTnDetails
 */
export interface AsyncResponseTnDetails {
    /**
     *
     * @type {string}
     * @memberof AsyncResponseTnDetails
     */
    tn: string;
    /**
     * Short Dialing Code to be used for VPN Dialing
     * @type {number}
     * @memberof AsyncResponseTnDetails
     */
    vpnDialingCode?: number;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof AsyncResponseTnDetails
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof AsyncResponseTnDetails
     */
    errorMessage?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const CallProtectIndicatorSchema = {
    Y: "Y",
    N: "N",
} as const;

export type CallProtectIndicatorSchema = (typeof CallProtectIndicatorSchema)[keyof typeof CallProtectIndicatorSchema];

/**
 *
 * @export
 * @interface CallingFeatureData
 */
export interface CallingFeatureData {
    /**
     * Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
     * @type {number}
     * @memberof CallingFeatureData
     */
    groupId: number;
    /**
     * Name of the feature to be retrieved
     * @type {string}
     * @memberof CallingFeatureData
     */
    featureName: CallingFeatureDataFeatureNameEnum;
    /**
     *
     * @type {HuntTypeSchema}
     * @memberof CallingFeatureData
     */
    huntType?: HuntTypeSchema;
    /**
     *
     * @type {DirectedGroupIndicatorSchema}
     * @memberof CallingFeatureData
     */
    directedGroupIndr?: DirectedGroupIndicatorSchema;
    /**
     *
     * @type {Array<TnDetails>}
     * @memberof CallingFeatureData
     */
    tnList?: Array<TnDetails>;
}

export const CallingFeatureDataFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;

export type CallingFeatureDataFeatureNameEnum = (typeof CallingFeatureDataFeatureNameEnum)[keyof typeof CallingFeatureDataFeatureNameEnum];

/**
 *
 * @export
 * @interface CallingFeatureResponse
 */
export interface CallingFeatureResponse {
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof CallingFeatureResponse
     */
    customerAccountId: string;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof CallingFeatureResponse
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof CallingFeatureResponse
     */
    errorMessage?: string;
    /**
     *
     * @type {CallingFeatureData}
     * @memberof CallingFeatureResponse
     */
    callingFeature?: CallingFeatureData;
}

/**
 *
 * @export
 * @interface CallingFeaturesAsyncResponse
 */
export interface CallingFeaturesAsyncResponse {
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof CallingFeaturesAsyncResponse
     */
    customerAccountId: string;
    /**
     *
     * @type {AsyncCallingFeatureData}
     * @memberof CallingFeaturesAsyncResponse
     */
    callingFeature?: AsyncCallingFeatureData;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof CallingFeaturesAsyncResponse
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof CallingFeaturesAsyncResponse
     */
    errorMessage?: string;
}

/**
 *
 * @export
 * @interface ChangeRequestSyncResponse
 */
export interface ChangeRequestSyncResponse {
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof ChangeRequestSyncResponse
     */
    orderNumber: string;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof ChangeRequestSyncResponse
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof ChangeRequestSyncResponse
     */
    errorMessage?: string;
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof ChangeRequestSyncResponse
     */
    customerAccountId: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const DirectedGroupIndicatorSchema = {
    Y: "Y",
    N: "N",
} as const;

export type DirectedGroupIndicatorSchema = (typeof DirectedGroupIndicatorSchema)[keyof typeof DirectedGroupIndicatorSchema];

/**
 * The type of hunting used for Multi-Line Hunt Group feature
 * @export
 * @enum {string}
 */

export const HuntTypeSchema = {
    HuntNone: "HUNT_NONE",
    SequentialHunt: "HUNT_SEQUENTIAL",
    CircularHunt: "HUNT_CIRCULAR",
    UniformHunt: "HUNT_UNIFORM",
    UniformHuntMember: "HUNT_UNIFORM_MEMBER",
} as const;

export type HuntTypeSchema = (typeof HuntTypeSchema)[keyof typeof HuntTypeSchema];

/**
 *
 * @export
 * @interface MemberTnDetails
 */
export interface MemberTnDetails {
    /**
     *
     * @type {string}
     * @memberof MemberTnDetails
     */
    tn: string;
    /**
     * Short Dialing Code to be used for VPN Dialing
     * @type {number}
     * @memberof MemberTnDetails
     */
    vpnDialingCode?: number;
}

/**
 *
 * @export
 * @interface NetworkParamsChangeRequestSyncResponse
 */
export interface NetworkParamsChangeRequestSyncResponse {
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof NetworkParamsChangeRequestSyncResponse
     */
    orderNumber: string;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof NetworkParamsChangeRequestSyncResponse
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof NetworkParamsChangeRequestSyncResponse
     */
    errorMessage?: string;
    /**
     *
     * @type {string}
     * @memberof NetworkParamsChangeRequestSyncResponse
     */
    tn: string;
}

/**
 *
 * @export
 * @interface NetworkProvParamUpdateRequest
 */
export interface NetworkProvParamUpdateRequest {
    priority: number;
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof NetworkProvParamUpdateRequest
     */
    orderNumber: string;
    /**
     *
     * @type {CallProtectIndicatorSchema}
     * @memberof NetworkProvParamUpdateRequest
     */
    callProtectIndr: CallProtectIndicatorSchema;
}

/**
 *
 * @export
 * @interface NetworkProvParamsResponse
 */
export interface NetworkProvParamsResponse {
    /**
     *
     * @type {string}
     * @memberof NetworkProvParamsResponse
     */
    tn: string;
    /**
     *
     * @type {CallProtectIndicatorSchema}
     * @memberof NetworkProvParamsResponse
     */
    callProtectIndr?: CallProtectIndicatorSchema;
    /**
     * Indicates the type of status or error for the order (0000 is success)
     * @type {string}
     * @memberof NetworkProvParamsResponse
     */
    errorCode: string;
    /**
     * Error details or messages
     * @type {string}
     * @memberof NetworkProvParamsResponse
     */
    errorMessage?: string;
}

/**
 *
 * @export
 * @interface RemoveCallingFeatureRequest
 */
export interface RemoveCallingFeatureRequest {
    /**
     * Provisioning priority for this transaction
     * @type {number}
     * @memberof RemoveCallingFeatureRequest
     */
    priority: number;
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof RemoveCallingFeatureRequest
     */
    orderNumber: string;
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof RemoveCallingFeatureRequest
     */
    customerAccountId: string;
}

/**
 *
 * @export
 * @interface ReplaceCallingFeaturesRequest
 */
export interface ReplaceCallingFeaturesRequest {
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof ReplaceCallingFeaturesRequest
     */
    customerAccountId: string;
    /**
     * Provisioning priority for this transaction
     * @type {number}
     * @memberof ReplaceCallingFeaturesRequest
     */
    priority: number;
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof ReplaceCallingFeaturesRequest
     */
    orderNumber: string;
    /**
     *
     * @type {DirectedGroupIndicatorSchema}
     * @memberof ReplaceCallingFeaturesRequest
     */
    directedGroupIndr: DirectedGroupIndicatorSchema;
    /**
     *
     * @type {Array<TnDetails>}
     * @memberof ReplaceCallingFeaturesRequest
     */
    tnList: Array<TnDetails>;
}

/**
 * Along with the HTTP Status code, a Problem Details object based on https://www.rfc-editor.org/rfc/rfc9457.html  will be provided. See https://nordicapis.com/a-look-at-problem-details-for-http-apis-rfc/ for more info.
 * @export
 * @interface StatusDetail
 */
export interface StatusDetail {
    /**
     * date and time the request was sent
     * @type {string}
     * @memberof StatusDetail
     */
    timeStamp?: string;
    /**
     * An absolute URI that identifies the problem type. Many of the errors will be of type 400, bad request. The type URI  would look like  https:<...>/errors/400/1 with the corresponding detail value of \'Missing required data element <field name> or  https:<...>/errors/400/2 with the detail value of \'Unexpected value <field name> = <field value message>\' or https:<...>/errors/400/3 with a detail value of \'Duplicate Transaction ID <transactionId>\' or https:<...>/errors/400/4 with a detail value of \'<In-progress message> for Site ID <siteIdentifier>\'
     * @type {string}
     * @memberof StatusDetail
     */
    type?: string;
    /**
     * A short summary of the problem type. In the case of success the title will simply be \'success\'
     * @type {string}
     * @memberof StatusDetail
     */
    title: string;
    /**
     * the HTTP status code generated by the origin server for this occurrence
     * @type {number}
     * @memberof StatusDetail
     */
    status: number;
    /**
     * a human-readable explanation specific to this occurrence of the problem. Required for error conditions.
     * @type {string}
     * @memberof StatusDetail
     */
    detail: string;
    /**
     * This is optional and to be used as an identifier for specific instances of this condition.
     * @type {string}
     * @memberof StatusDetail
     */
    instance?: string;
}

/**
 *
 * @export
 * @interface TnDetails
 */
export interface TnDetails {
    /**
     *
     * @type {string}
     * @memberof TnDetails
     */
    tn: string;
    /**
     * Short Dialing Code to be used for VPN Dialing
     * @type {number}
     * @memberof TnDetails
     */
    vpnDialingCode?: number;
}

/**
 * Change the the entire group\'s directed indicator and/or change tns in the list and/or change a tn\'s extension code
 * @export
 * @interface UpdateCallingFeaturesRequest
 */
export interface UpdateCallingFeaturesRequest {
    /**
     * UB Sub Account Number for the Customer
     * @type {string}
     * @memberof UpdateCallingFeaturesRequest
     */
    customerAccountId: string;
    /**
     * Provisioning priority for this transaction
     * @type {number}
     * @memberof UpdateCallingFeaturesRequest
     */
    priority: number;
    /**
     * Service order number (Generated by VFC Portal)
     * @type {string}
     * @memberof UpdateCallingFeaturesRequest
     */
    orderNumber: string;
    /**
     *
     * @type {Array<UpdateTnDetails>}
     * @memberof UpdateCallingFeaturesRequest
     */
    tnList: Array<UpdateTnDetails>;
}

/**
 *
 * @export
 * @interface UpdateTnDetails
 */
export interface UpdateTnDetails {
    /**
     *
     * @type {string}
     * @memberof UpdateTnDetails
     */
    tn: string;
    /**
     * The action that will be taken for this TN
     * @type {string}
     * @memberof UpdateTnDetails
     */
    action: UpdateTnDetailsActionEnum;
    /**
     * Short Dialing Code to be used for VPN Dialing
     * @type {number}
     * @memberof UpdateTnDetails
     */
    vpnDialingCode?: number;
}

export const UpdateTnDetailsActionEnum = {
    A: "A",
    C: "C",
    D: "D",
} as const;

export type UpdateTnDetailsActionEnum = (typeof UpdateTnDetailsActionEnum)[keyof typeof UpdateTnDetailsActionEnum];

/**
 *
 * @export
 * @interface VFCCErrorResponse
 */
export interface VFCCErrorResponse {
    /**
     *
     * @type {number}
     * @memberof VFCCErrorResponse
     */
    code?: number;
    /**
     *
     * @type {string}
     * @memberof VFCCErrorResponse
     */
    message?: string;
}

/**
 * AdvancedCallingFeaturesApi - axios parameter creator
 * @export
 */
export const AdvancedCallingFeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Calling Feature with TNs
         * @summary Add a new Calling Feature with TNs
         * @param {AddCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {AddCallingFeaturesRequest} addCallingFeaturesRequest AddCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCallingFeaturesService: async (
            featureName: AddCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            addCallingFeaturesRequest: AddCallingFeaturesRequest,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists("addCallingFeaturesService", "featureName", featureName);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("addCallingFeaturesService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("addCallingFeaturesService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("addCallingFeaturesService", "date", date);
            // verify required parameter 'addCallingFeaturesRequest' is not null or undefined
            assertParamExists("addCallingFeaturesService", "addCallingFeaturesRequest", addCallingFeaturesRequest);
            const localVarPath = `/callingfeatures/{featureName}`.replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(addCallingFeaturesRequest, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove an existing Calling Feature for a Customer and purge any tn-level restrictions associated with it
         * @summary Remove an existing Calling Feature
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {RemoveCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {string} orderNumber
         * @param {number} priority
         * @param {string} customerAccountId The UB Sub Account Number for the Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCallingFeaturesService: async (
            groupId: number,
            featureName: RemoveCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            orderNumber: string,
            priority: number,
            customerAccountId: string,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "groupId", groupId);
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "featureName", featureName);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "date", date);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "orderNumber", orderNumber);
            // verify required parameter 'priority' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "priority", priority);
            // verify required parameter 'customerAccountId' is not null or undefined
            assertParamExists("removeCallingFeaturesService", "customerAccountId", customerAccountId);
            const localVarPath = `/callingfeatures/{featureName}/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderNumber !== undefined) {
                localVarQueryParameter["orderNumber"] = orderNumber;
            }

            if (priority !== undefined) {
                localVarQueryParameter["priority"] = priority;
            }

            if (customerAccountId !== undefined) {
                localVarQueryParameter["customerAccountId"] = customerAccountId;
            }

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Call Park/Pickup group\'s directed indicator
         * @summary Change Call Park/Pickup group\'s directed indicator
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {ReplaceCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {ReplaceCallingFeaturesRequest} [replaceCallingFeaturesRequest] ReplaceCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCallingFeaturesService: async (
            groupId: number,
            featureName: ReplaceCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            replaceCallingFeaturesRequest?: ReplaceCallingFeaturesRequest,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists("replaceCallingFeaturesService", "groupId", groupId);
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists("replaceCallingFeaturesService", "featureName", featureName);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("replaceCallingFeaturesService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("replaceCallingFeaturesService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("replaceCallingFeaturesService", "date", date);
            const localVarPath = `/callingfeatures/{featureName}/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(replaceCallingFeaturesRequest, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve Calling Features by id
         * @summary Retrieve Calling Feature information by Id
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {RetrieveCallingFeatureByIdFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCallingFeatureById: async (
            groupId: number,
            featureName: RetrieveCallingFeatureByIdFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists("retrieveCallingFeatureById", "groupId", groupId);
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists("retrieveCallingFeatureById", "featureName", featureName);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("retrieveCallingFeatureById", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("retrieveCallingFeatureById", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("retrieveCallingFeatureById", "date", date);
            const localVarPath = `/callingfeatures/{featureName}/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve Calling Features information for a Customer
         * @summary Retrieve Calling Features information for a Customer
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {string} customerAccountId The UB Sub Account Number for the Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCallingFeaturesService: async (
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            customerAccountId: string,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("retrieveCallingFeaturesService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("retrieveCallingFeaturesService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("retrieveCallingFeaturesService", "date", date);
            // verify required parameter 'customerAccountId' is not null or undefined
            assertParamExists("retrieveCallingFeaturesService", "customerAccountId", customerAccountId);
            const localVarPath = `/callingfeatures/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerAccountId !== undefined) {
                localVarQueryParameter["customerAccountId"] = customerAccountId;
            }

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change tns in the list and/or change a tn\'s extension code if applicable
         * @summary Change Tns or Tn details Within a Calling Feature
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {UpdateCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {UpdateCallingFeaturesRequest} updateCallingFeaturesRequest UpdateCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallingFeaturesService: async (
            groupId: number,
            featureName: UpdateCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            updateCallingFeaturesRequest: UpdateCallingFeaturesRequest,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists("updateCallingFeaturesService", "groupId", groupId);
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists("updateCallingFeaturesService", "featureName", featureName);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("updateCallingFeaturesService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("updateCallingFeaturesService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("updateCallingFeaturesService", "date", date);
            // verify required parameter 'updateCallingFeaturesRequest' is not null or undefined
            assertParamExists("updateCallingFeaturesService", "updateCallingFeaturesRequest", updateCallingFeaturesRequest);
            const localVarPath = `/callingfeatures/{featureName}/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PATCH",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateCallingFeaturesRequest, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * AdvancedCallingFeaturesApi - functional programming interface
 * @export
 */
export const AdvancedCallingFeaturesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = AdvancedCallingFeaturesApiAxiosParamCreator(configuration);
    return {
        /**
         * Add a new Calling Feature with TNs
         * @summary Add a new Calling Feature with TNs
         * @param {AddCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {AddCallingFeaturesRequest} addCallingFeaturesRequest AddCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCallingFeaturesService(
            featureName: AddCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            addCallingFeaturesRequest: AddCallingFeaturesRequest,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCallingFeaturesService(
                featureName,
                xATTClientId,
                xATTMessageId,
                date,
                addCallingFeaturesRequest,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["AdvancedCallingFeaturesApi.addCallingFeaturesService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove an existing Calling Feature for a Customer and purge any tn-level restrictions associated with it
         * @summary Remove an existing Calling Feature
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {RemoveCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {string} orderNumber
         * @param {number} priority
         * @param {string} customerAccountId The UB Sub Account Number for the Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCallingFeaturesService(
            groupId: number,
            featureName: RemoveCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            orderNumber: string,
            priority: number,
            customerAccountId: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCallingFeaturesService(
                groupId,
                featureName,
                xATTClientId,
                xATTMessageId,
                date,
                orderNumber,
                priority,
                customerAccountId,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["AdvancedCallingFeaturesApi.removeCallingFeaturesService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Change Call Park/Pickup group\'s directed indicator
         * @summary Change Call Park/Pickup group\'s directed indicator
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {ReplaceCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {ReplaceCallingFeaturesRequest} [replaceCallingFeaturesRequest] ReplaceCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceCallingFeaturesService(
            groupId: number,
            featureName: ReplaceCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            replaceCallingFeaturesRequest?: ReplaceCallingFeaturesRequest,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceCallingFeaturesService(
                groupId,
                featureName,
                xATTClientId,
                xATTMessageId,
                date,
                replaceCallingFeaturesRequest,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["AdvancedCallingFeaturesApi.replaceCallingFeaturesService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieve Calling Features by id
         * @summary Retrieve Calling Feature information by Id
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {RetrieveCallingFeatureByIdFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCallingFeatureById(
            groupId: number,
            featureName: RetrieveCallingFeatureByIdFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallingFeatureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCallingFeatureById(
                groupId,
                featureName,
                xATTClientId,
                xATTMessageId,
                date,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["AdvancedCallingFeaturesApi.retrieveCallingFeatureById"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retrieve Calling Features information for a Customer
         * @summary Retrieve Calling Features information for a Customer
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {string} customerAccountId The UB Sub Account Number for the Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCallingFeaturesService(
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            customerAccountId: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllCallingFeaturesForAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCallingFeaturesService(
                xATTClientId,
                xATTMessageId,
                date,
                customerAccountId,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["AdvancedCallingFeaturesApi.retrieveCallingFeaturesService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Change tns in the list and/or change a tn\'s extension code if applicable
         * @summary Change Tns or Tn details Within a Calling Feature
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {UpdateCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {UpdateCallingFeaturesRequest} updateCallingFeaturesRequest UpdateCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCallingFeaturesService(
            groupId: number,
            featureName: UpdateCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            updateCallingFeaturesRequest: UpdateCallingFeaturesRequest,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeRequestSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCallingFeaturesService(
                groupId,
                featureName,
                xATTClientId,
                xATTMessageId,
                date,
                updateCallingFeaturesRequest,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["AdvancedCallingFeaturesApi.updateCallingFeaturesService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * AdvancedCallingFeaturesApi - factory interface
 * @export
 */
export const AdvancedCallingFeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdvancedCallingFeaturesApiFp(configuration);
    return {
        /**
         * Add a new Calling Feature with TNs
         * @summary Add a new Calling Feature with TNs
         * @param {AddCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {AddCallingFeaturesRequest} addCallingFeaturesRequest AddCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCallingFeaturesService(
            featureName: AddCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            addCallingFeaturesRequest: AddCallingFeaturesRequest,
            options?: any,
        ): AxiosPromise<ChangeRequestSyncResponse> {
            return localVarFp
                .addCallingFeaturesService(featureName, xATTClientId, xATTMessageId, date, addCallingFeaturesRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Remove an existing Calling Feature for a Customer and purge any tn-level restrictions associated with it
         * @summary Remove an existing Calling Feature
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {RemoveCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {string} orderNumber
         * @param {number} priority
         * @param {string} customerAccountId The UB Sub Account Number for the Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCallingFeaturesService(
            groupId: number,
            featureName: RemoveCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            orderNumber: string,
            priority: number,
            customerAccountId: string,
            options?: any,
        ): AxiosPromise<ChangeRequestSyncResponse> {
            return localVarFp
                .removeCallingFeaturesService(groupId, featureName, xATTClientId, xATTMessageId, date, orderNumber, priority, customerAccountId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Change Call Park/Pickup group\'s directed indicator
         * @summary Change Call Park/Pickup group\'s directed indicator
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {ReplaceCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {ReplaceCallingFeaturesRequest} [replaceCallingFeaturesRequest] ReplaceCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCallingFeaturesService(
            groupId: number,
            featureName: ReplaceCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            replaceCallingFeaturesRequest?: ReplaceCallingFeaturesRequest,
            options?: any,
        ): AxiosPromise<ChangeRequestSyncResponse> {
            return localVarFp
                .replaceCallingFeaturesService(groupId, featureName, xATTClientId, xATTMessageId, date, replaceCallingFeaturesRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Calling Features by id
         * @summary Retrieve Calling Feature information by Id
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {RetrieveCallingFeatureByIdFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCallingFeatureById(
            groupId: number,
            featureName: RetrieveCallingFeatureByIdFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            options?: any,
        ): AxiosPromise<CallingFeatureResponse> {
            return localVarFp
                .retrieveCallingFeatureById(groupId, featureName, xATTClientId, xATTMessageId, date, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Calling Features information for a Customer
         * @summary Retrieve Calling Features information for a Customer
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {string} customerAccountId The UB Sub Account Number for the Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCallingFeaturesService(
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            customerAccountId: string,
            options?: any,
        ): AxiosPromise<AllCallingFeaturesForAccountResponse> {
            return localVarFp
                .retrieveCallingFeaturesService(xATTClientId, xATTMessageId, date, customerAccountId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Change tns in the list and/or change a tn\'s extension code if applicable
         * @summary Change Tns or Tn details Within a Calling Feature
         * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
         * @param {UpdateCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {UpdateCallingFeaturesRequest} updateCallingFeaturesRequest UpdateCallingFeaturesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCallingFeaturesService(
            groupId: number,
            featureName: UpdateCallingFeaturesServiceFeatureNameEnum,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            updateCallingFeaturesRequest: UpdateCallingFeaturesRequest,
            options?: any,
        ): AxiosPromise<ChangeRequestSyncResponse> {
            return localVarFp
                .updateCallingFeaturesService(groupId, featureName, xATTClientId, xATTMessageId, date, updateCallingFeaturesRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdvancedCallingFeaturesApi - object-oriented interface
 * @export
 * @class AdvancedCallingFeaturesApi
 * @extends {BaseAPI}
 */
export class AdvancedCallingFeaturesApi extends BaseAPI {
    /**
     * Add a new Calling Feature with TNs
     * @summary Add a new Calling Feature with TNs
     * @param {AddCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {AddCallingFeaturesRequest} addCallingFeaturesRequest AddCallingFeaturesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedCallingFeaturesApi
     */
    public addCallingFeaturesService(
        featureName: AddCallingFeaturesServiceFeatureNameEnum,
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        addCallingFeaturesRequest: AddCallingFeaturesRequest,
        options?: RawAxiosRequestConfig,
    ) {
        return AdvancedCallingFeaturesApiFp(this.configuration)
            .addCallingFeaturesService(featureName, xATTClientId, xATTMessageId, date, addCallingFeaturesRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove an existing Calling Feature for a Customer and purge any tn-level restrictions associated with it
     * @summary Remove an existing Calling Feature
     * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
     * @param {RemoveCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {string} orderNumber
     * @param {number} priority
     * @param {string} customerAccountId The UB Sub Account Number for the Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedCallingFeaturesApi
     */
    public removeCallingFeaturesService(
        groupId: number,
        featureName: RemoveCallingFeaturesServiceFeatureNameEnum,
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        orderNumber: string,
        priority: number,
        customerAccountId: string,
        options?: RawAxiosRequestConfig,
    ) {
        return AdvancedCallingFeaturesApiFp(this.configuration)
            .removeCallingFeaturesService(groupId, featureName, xATTClientId, xATTMessageId, date, orderNumber, priority, customerAccountId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Call Park/Pickup group\'s directed indicator
     * @summary Change Call Park/Pickup group\'s directed indicator
     * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
     * @param {ReplaceCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {ReplaceCallingFeaturesRequest} [replaceCallingFeaturesRequest] ReplaceCallingFeaturesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedCallingFeaturesApi
     */
    public replaceCallingFeaturesService(
        groupId: number,
        featureName: ReplaceCallingFeaturesServiceFeatureNameEnum,
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        replaceCallingFeaturesRequest?: ReplaceCallingFeaturesRequest,
        options?: RawAxiosRequestConfig,
    ) {
        return AdvancedCallingFeaturesApiFp(this.configuration)
            .replaceCallingFeaturesService(groupId, featureName, xATTClientId, xATTMessageId, date, replaceCallingFeaturesRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve Calling Features by id
     * @summary Retrieve Calling Feature information by Id
     * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
     * @param {RetrieveCallingFeatureByIdFeatureNameEnum} featureName Name of the feature to be retrieved
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedCallingFeaturesApi
     */
    public retrieveCallingFeatureById(
        groupId: number,
        featureName: RetrieveCallingFeatureByIdFeatureNameEnum,
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        options?: RawAxiosRequestConfig,
    ) {
        return AdvancedCallingFeaturesApiFp(this.configuration)
            .retrieveCallingFeatureById(groupId, featureName, xATTClientId, xATTMessageId, date, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve Calling Features information for a Customer
     * @summary Retrieve Calling Features information for a Customer
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {string} customerAccountId The UB Sub Account Number for the Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedCallingFeaturesApi
     */
    public retrieveCallingFeaturesService(
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        customerAccountId: string,
        options?: RawAxiosRequestConfig,
    ) {
        return AdvancedCallingFeaturesApiFp(this.configuration)
            .retrieveCallingFeaturesService(xATTClientId, xATTMessageId, date, customerAccountId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change tns in the list and/or change a tn\'s extension code if applicable
     * @summary Change Tns or Tn details Within a Calling Feature
     * @param {number} groupId Group Id OR VPN Id (for VpnDialing) of the Group to be retrieved
     * @param {UpdateCallingFeaturesServiceFeatureNameEnum} featureName Name of the feature to be retrieved
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {UpdateCallingFeaturesRequest} updateCallingFeaturesRequest UpdateCallingFeaturesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedCallingFeaturesApi
     */
    public updateCallingFeaturesService(
        groupId: number,
        featureName: UpdateCallingFeaturesServiceFeatureNameEnum,
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        updateCallingFeaturesRequest: UpdateCallingFeaturesRequest,
        options?: RawAxiosRequestConfig,
    ) {
        return AdvancedCallingFeaturesApiFp(this.configuration)
            .updateCallingFeaturesService(groupId, featureName, xATTClientId, xATTMessageId, date, updateCallingFeaturesRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AddCallingFeaturesServiceFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;
export type AddCallingFeaturesServiceFeatureNameEnum = (typeof AddCallingFeaturesServiceFeatureNameEnum)[keyof typeof AddCallingFeaturesServiceFeatureNameEnum];
/**
 * @export
 */
export const RemoveCallingFeaturesServiceFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;
export type RemoveCallingFeaturesServiceFeatureNameEnum =
    (typeof RemoveCallingFeaturesServiceFeatureNameEnum)[keyof typeof RemoveCallingFeaturesServiceFeatureNameEnum];
/**
 * @export
 */
export const ReplaceCallingFeaturesServiceFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;
export type ReplaceCallingFeaturesServiceFeatureNameEnum =
    (typeof ReplaceCallingFeaturesServiceFeatureNameEnum)[keyof typeof ReplaceCallingFeaturesServiceFeatureNameEnum];
/**
 * @export
 */
export const RetrieveCallingFeatureByIdFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;
export type RetrieveCallingFeatureByIdFeatureNameEnum =
    (typeof RetrieveCallingFeatureByIdFeatureNameEnum)[keyof typeof RetrieveCallingFeatureByIdFeatureNameEnum];
/**
 * @export
 */
export const UpdateCallingFeaturesServiceFeatureNameEnum = {
    CallPark: "CallPark",
    CallPickUp: "CallPickUp",
    Mlhg: "MLHG",
    VpnDialing: "VpnDialing",
} as const;
export type UpdateCallingFeaturesServiceFeatureNameEnum =
    (typeof UpdateCallingFeaturesServiceFeatureNameEnum)[keyof typeof UpdateCallingFeaturesServiceFeatureNameEnum];

/**
 * NetworkProvisioningSettingsApi - axios parameter creator
 * @export
 */
export const NetworkProvisioningSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves parameters for network provisioning for a single TN.
         * @summary Retrieves parameters for network provisioning for a single TN
         * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNetworkProvParamService: async (
            tn: string,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'tn' is not null or undefined
            assertParamExists("retrieveNetworkProvParamService", "tn", tn);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("retrieveNetworkProvParamService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("retrieveNetworkProvParamService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("retrieveNetworkProvParamService", "date", date);
            const localVarPath = `/networkprovparams/{tn}`.replace(`{${"tn"}}`, encodeURIComponent(String(tn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specified parameter used in network provisioning for a TN
         * @summary Update a specified parameter used in network provisioning for a TN
         * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {NetworkProvParamUpdateRequest} networkProvParamUpdateRequest NetworkProvParamUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkProvParamService: async (
            tn: string,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            networkProvParamUpdateRequest: NetworkProvParamUpdateRequest,
            options: RawAxiosRequestConfig = {},
        ): Promise<RequestArgs> => {
            // verify required parameter 'tn' is not null or undefined
            assertParamExists("updateNetworkProvParamService", "tn", tn);
            // verify required parameter 'xATTClientId' is not null or undefined
            assertParamExists("updateNetworkProvParamService", "xATTClientId", xATTClientId);
            // verify required parameter 'xATTMessageId' is not null or undefined
            assertParamExists("updateNetworkProvParamService", "xATTMessageId", xATTMessageId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists("updateNetworkProvParamService", "date", date);
            // verify required parameter 'networkProvParamUpdateRequest' is not null or undefined
            assertParamExists("updateNetworkProvParamService", "networkProvParamUpdateRequest", networkProvParamUpdateRequest);
            const localVarPath = `/networkprovparams/{tn}`.replace(`{${"tn"}}`, encodeURIComponent(String(tn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "PATCH",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xATTClientId != null) {
                localVarHeaderParameter["X-ATT-ClientId"] = String(xATTClientId);
            }

            if (xATTMessageId != null) {
                localVarHeaderParameter["X-ATT-MessageId"] = String(xATTMessageId);
            }

            if (date != null) {
                localVarHeaderParameter["X-ATT-Date"] = typeof date === "string" ? date : JSON.stringify(date);
            }

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(networkProvParamUpdateRequest, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * NetworkProvisioningSettingsApi - functional programming interface
 * @export
 */
export const NetworkProvisioningSettingsApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = NetworkProvisioningSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves parameters for network provisioning for a single TN.
         * @summary Retrieves parameters for network provisioning for a single TN
         * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveNetworkProvParamService(
            tn: string,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkProvParamsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveNetworkProvParamService(tn, xATTClientId, xATTMessageId, date, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["NetworkProvisioningSettingsApi.retrieveNetworkProvParamService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a specified parameter used in network provisioning for a TN
         * @summary Update a specified parameter used in network provisioning for a TN
         * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {NetworkProvParamUpdateRequest} networkProvParamUpdateRequest NetworkProvParamUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNetworkProvParamService(
            tn: string,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            networkProvParamUpdateRequest: NetworkProvParamUpdateRequest,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkParamsChangeRequestSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNetworkProvParamService(
                tn,
                xATTClientId,
                xATTMessageId,
                date,
                networkProvParamUpdateRequest,
                options,
            );
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["NetworkProvisioningSettingsApi.updateNetworkProvParamService"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * NetworkProvisioningSettingsApi - factory interface
 * @export
 */
export const NetworkProvisioningSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetworkProvisioningSettingsApiFp(configuration);
    return {
        /**
         * Retrieves parameters for network provisioning for a single TN.
         * @summary Retrieves parameters for network provisioning for a single TN
         * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNetworkProvParamService(
            tn: string,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            options?: any,
        ): AxiosPromise<NetworkProvParamsResponse> {
            return localVarFp.retrieveNetworkProvParamService(tn, xATTClientId, xATTMessageId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specified parameter used in network provisioning for a TN
         * @summary Update a specified parameter used in network provisioning for a TN
         * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
         * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
         * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
         * @param {string} date The date of the request.
         * @param {NetworkProvParamUpdateRequest} networkProvParamUpdateRequest NetworkProvParamUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkProvParamService(
            tn: string,
            xATTClientId: string,
            xATTMessageId: string,
            date: string,
            networkProvParamUpdateRequest: NetworkProvParamUpdateRequest,
            options?: any,
        ): AxiosPromise<NetworkParamsChangeRequestSyncResponse> {
            return localVarFp
                .updateNetworkProvParamService(tn, xATTClientId, xATTMessageId, date, networkProvParamUpdateRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkProvisioningSettingsApi - object-oriented interface
 * @export
 * @class NetworkProvisioningSettingsApi
 * @extends {BaseAPI}
 */
export class NetworkProvisioningSettingsApi extends BaseAPI {
    /**
     * Retrieves parameters for network provisioning for a single TN.
     * @summary Retrieves parameters for network provisioning for a single TN
     * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkProvisioningSettingsApi
     */
    public retrieveNetworkProvParamService(tn: string, xATTClientId: string, xATTMessageId: string, date: string, options?: RawAxiosRequestConfig) {
        return NetworkProvisioningSettingsApiFp(this.configuration)
            .retrieveNetworkProvParamService(tn, xATTClientId, xATTMessageId, date, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specified parameter used in network provisioning for a TN
     * @summary Update a specified parameter used in network provisioning for a TN
     * @param {string} tn The TN for which network provisioning parameters are to be retrieved.
     * @param {string} xATTClientId Identifies the originating principal of a request where the API must  be executed under the principal value provided (i.e., work on behalf of).  This header must only be accepted from trusted sources.
     * @param {string} xATTMessageId A client provided UUID value that uniquely identifies a client generated message sent to a server. May be used as a correlation identifier via X-ATT-CorrelationId for asynchronous responses.
     * @param {string} date The date of the request.
     * @param {NetworkProvParamUpdateRequest} networkProvParamUpdateRequest NetworkProvParamUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkProvisioningSettingsApi
     */
    public updateNetworkProvParamService(
        tn: string,
        xATTClientId: string,
        xATTMessageId: string,
        date: string,
        networkProvParamUpdateRequest: NetworkProvParamUpdateRequest,
        options?: RawAxiosRequestConfig,
    ) {
        return NetworkProvisioningSettingsApiFp(this.configuration)
            .updateNetworkProvParamService(tn, xATTClientId, xATTMessageId, date, networkProvParamUpdateRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
